
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsPosMoneyCountDialog extends Serenity.EntityDialog<PsPosMoneyCountRow, any> {
        protected getFormKey() { return PsPosMoneyCountForm.formKey; }
        protected getIdProperty() { return PsPosMoneyCountRow.idProperty; }
        protected getLocalTextPrefix() { return PsPosMoneyCountRow.localTextPrefix; }
        protected getNameProperty() { return PsPosMoneyCountRow.nameProperty; }
        protected getService() { return PsPosMoneyCountService.baseUrl; }
        protected getDeletePermission() { return PsPosMoneyCountRow.deletePermission; }
        protected getInsertPermission() { return PsPosMoneyCountRow.insertPermission; }
        protected getUpdatePermission() { return PsPosMoneyCountRow.updatePermission; }

        protected form = new PsPosMoneyCountForm(this.idPrefix);

    }
}